import LazyLoad from "vanilla-lazyload";
//import Masonry from "masonry-layout";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import Isotope from "isotope-layout";
import Player from "@vimeo/player";
import zenscroll from "zenscroll";

import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText, ScrollTrigger);

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const mainEl = document.querySelector("main");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
const overlayInner = overlay.querySelector(".inner");
const overlayCloser = overlay.querySelector(".closer");

window.addEventListener("load", function () {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  if (window.Termly && typeof window.Termly.getConsentState === "function") {
    Termly.on("consent", (data) => {
      let targetEl = document.querySelector("#sizzle .cell .mediawrap");

      const consentState = window.Termly.getConsentState();
      //console.log(consentState);

      if (!consentState.performance) {
        setTimeout(function () {
          soundBtnsInit();
        }, 100);
      } else {
        setTimeout(function () {
          if (typeof targetEl != "undefined" && targetEl != null) {
            let fallBackVideo = targetEl.querySelector("video.fallback");
            fallBackVideo.parentNode.removeChild(fallBackVideo);
            soundBtnsInit();
          }
        }, 100);
      }
    });
  }

  // global animation effects
  ScrollTrigger.batch(".fadeUp", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
    },
  });

  ScrollTrigger.batch(".fadeOn", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, stagger: 0.1 });
    },
  });

  setTimeout(function () {
    ScrollTrigger.batch(".fadeUpDelay", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
      },
    });
  }, 300);

  // rotating blocks timer
  let rotatingBlocksEl = document.querySelector(".rotating_cells");
  if (typeof rotatingBlocksEl != "undefined" && rotatingBlocksEl != null) {
    let rBlock1 = rotatingBlocksEl.querySelector(".cell.first");
    let rBlock2 = rotatingBlocksEl.querySelector(".cell.second");
    let rBlock3 = rotatingBlocksEl.querySelector(".cell.third");
    const block1ID = setInterval(rotateImage, 5000, rBlock1);
    setTimeout(function () {
      const block2ID = setInterval(rotateImage, 5000, rBlock2);
    }, 250);
    setTimeout(function () {
      const block3ID = setInterval(rotateImage, 5000, rBlock3);
    }, 500);

    function rotateImage(cell) {
      let activeImg = cell.querySelector("img.active");
      let nextImg = activeImg.nextElementSibling;
      if (typeof nextImg === "undefined" || nextImg == null) {
        nextImg = cell.querySelector("img");
      }
      activeImg.classList.add("leave");
      nextImg.classList.add("active");

      let nextLink = nextImg.getAttribute("data-url");
      cell.querySelector("a").setAttribute("href", nextLink);

      setTimeout(function () {
        activeImg.classList.remove("active", "leave");
      }, 1100);

      let activeTitle = cell.querySelector("p span.active");
      let nextTitle = activeTitle.nextElementSibling;
      if (typeof nextTitle === "undefined" || nextTitle == null) {
        nextTitle = cell.querySelector("p span");
      }
      activeTitle.classList.remove("active");
      nextTitle.classList.add("active");
    }
  }

  // hero text animation
  let heroEl = document.querySelector(".hero");
  if (typeof heroEl != "undefined" && heroEl != null) {
    let headline = heroEl.querySelector("h1");
    if (!headline) {
      headline = heroEl.querySelector("h2");
    }
    let firstheadline = heroEl.querySelector("h4.first");
    let subheadline = heroEl.querySelector("h4");
    let text = heroEl.querySelector("p");
    let social = heroEl.querySelector(".share");
    let button = heroEl.querySelector(".button");
    let bgH1 = heroEl.querySelectorAll(".background h1");
    let heroBackground = heroEl.querySelector(".background");
    let bgH1Color, heroBackgroundvideo;
    if (typeof heroBackground != "undefined" && heroBackground != null) {
      heroBackgroundvideo = heroBackground.querySelector("video");
      bgH1Color = heroEl
        .querySelector(".background")
        .getAttribute("data-color");
      gsap.set(bgH1, { webkitTextStrokeColor: bgH1Color });
    }

    let heroMedia = heroEl.querySelector(".media");

    // set opacity and y value to prep for animation
    gsap.set(headline, { opacity: 0 });
    gsap.set(button, { opacity: 0, y: 25 });
    gsap.set(subheadline, { opacity: 0, y: 25 });
    gsap.set(text, { opacity: 0, y: 25 });
    gsap.set(social, { opacity: 0, y: 25 });
    gsap.set(heroMedia, { opacity: 0, y: 50 });

    let sawAnimation = false;
    // animation starts
    if (
      typeof heroBackgroundvideo != "undefined" &&
      heroBackgroundvideo != null
    ) {
      // video background - load appropriate file based on window size

      let videoSourceEl = heroBackground.querySelector("source");
      let desktopSrc = heroBackgroundvideo.getAttribute("data-desktop");
      let mobileSrc = heroBackgroundvideo.getAttribute("data-mobile");

      if (window.innerWidth > 1023) {
        videoSourceEl.setAttribute("src", desktopSrc);
      } else {
        videoSourceEl.setAttribute("src", mobileSrc);
      }
      heroBackgroundvideo.load();
      heroBackgroundvideo.play();

      heroBackgroundvideo.addEventListener("playing", function () {
        setTimeout(function () {
          if (!sawAnimation) {
            startAnimation();
          }
        }, 500);
      });
    } else {
      if (!sawAnimation) {
        startAnimation();
      }
    }

    function startAnimation() {
      sawAnimation = true;

      gsap.to(firstheadline, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power4.out",
        delay: 0.5,
      });

      gsap.to(headline, {
        opacity: 1,
        duration: 1,
        delay: 1,
        ease: "power4.out",
      });

      // split hero headlines into lines
      let split = new SplitText(headline, { type: "lines" });
      let splitTextTimeline = gsap.timeline();
      splitTextTimeline.from(split.lines, {
        duration: 1,
        autoAlpha: 0,
        y: "25px",
        ease: "ease-out",
        stagger: 0.5,
        delay: 1,
        onComplete: function () {
          gsap.to(subheadline, {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "power4.out",
          });
          gsap.to(text, {
            opacity: 1,
            y: 0,
            duration: 1,
            delay: 0,
            ease: "power4.out",
          });
          gsap.to(button, {
            opacity: 1,
            y: 0,
            duration: 1,
            delay: 0,
            ease: "power4.out",
          });
          gsap.to(social, {
            opacity: 1,
            y: 0,
            duration: 1,
            delay: 0,
            ease: "power4.out",
          });
        },
      });

      // trigger line animation
      //gsap.to(bgH1, {clipPath: "inset(0 0% 0 0)", duration: 4})
      if (innerWidth < 1024) {
        gsap.to(heroMedia, {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 1.3,
          ease: "power4.out",
        });
      } else {
        gsap.to(heroMedia, {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 0.5,
          ease: "power4.out",
        });
      }
    }
  }

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // any col from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block .inner");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  function inviewInit() {
    // load priority images right away
    let priorityImgs = document.querySelectorAll("img.loadmepriority");
    priorityImgs.forEach((priorityImg) => {
      loadImage(priorityImg);
    });

    //initialize lazyload - sitewide for image
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });

    //initialize lazyload - autoplay videos
    const lazyLoadAutoVideo = new LazyLoad({
      elements_selector: ".autovideo",
      threshold: 30,
      callback_enter: playAutoVideo,
      callback_exit: pauseAutoVideo,
    });
  }

  function inviewAjaxInit() {
    //initialize lazyload - sitewide for image
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeviewajax",
      callback_enter: loadImage,
    });

    //initialize lazyload - autoplay videos
    const lazyLoadAutoVideo = new LazyLoad({
      elements_selector: ".autovideoajax",
      threshold: 30,
      callback_enter: playAutoVideo,
      callback_exit: pauseAutoVideo,
    });
  }

  inviewInit();

  // mimic the :hover effect on mobile for cropped grid cells as they scroll into view
  const mobileHoverCellSelector =
    ".grid.three_col_cropped .cell, .grid.two_col_cropped .cell";
  const mobileGridHoverQuery = window.matchMedia(
    "(max-width: 767px) and (orientation: portrait)",
  );
  let mobileCellEnterObserver = null;
  let mobileCellExitObserver = null;

  function observeMobileGridCells(container) {
    if (!mobileGridHoverQuery.matches) return;

    if (!mobileCellEnterObserver) {
      mobileCellEnterObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-inview");
            }
          });
        },
        { threshold: 1 },
      );

      // grow the root 100px past the real viewport edges so the reveal
      // only resets once a cell is well out of sight, not right as it
      // crosses the edge
      mobileCellExitObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              entry.target.classList.remove("is-inview");
            }
          });
        },
        { threshold: 0, rootMargin: "100px 0px 100px 0px" },
      );
    }

    (container || document)
      .querySelectorAll(mobileHoverCellSelector)
      .forEach((cell) => {
        mobileCellEnterObserver.observe(cell);
        mobileCellExitObserver.observe(cell);
      });
  }

  function disconnectMobileGridCells() {
    if (mobileCellEnterObserver) {
      mobileCellEnterObserver.disconnect();
      mobileCellEnterObserver = null;
    }
    if (mobileCellExitObserver) {
      mobileCellExitObserver.disconnect();
      mobileCellExitObserver = null;
    }
    document.querySelectorAll(mobileHoverCellSelector).forEach((cell) => {
      cell.classList.remove("is-inview");
    });
  }

  observeMobileGridCells();

  mobileGridHoverQuery.addEventListener("change", (e) => {
    if (e.matches) {
      observeMobileGridCells();
    } else {
      disconnectMobileGridCells();
    }
  });

  // isotope grid filtering for work page
  let iso;
  const isoGrid = document.querySelector(".iso-grid");
  if (typeof isoGrid != "undefined" && isoGrid != null) {
    iso = new Isotope(isoGrid, {
      // options
      itemSelector: ".cell",
      percentPosition: true,
      masonry: {
        columnWidth: ".grid-sizer",
        gutter: ".gutter-sizer",
      },
    });
  }

  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  // initialize flickity for carousels
  let carouselEl = document.querySelector(".carousel .wrapper");
  if (typeof carouselEl != "undefined" && carouselEl != null) {
    let carouselParent = carouselEl.closest(".carousel");
    let carouselSpeed = 3000;
    if (carouselParent.classList.contains("small")) {
      carouselSpeed = 0;
    }

    let flkty = new Flickity(carouselEl, {
      // options
      cellSelector: ".cell",
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      draggable: true,
      autoPlay: carouselSpeed,
      pauseAutoPlayOnHover: false,
    });

    let slides = carouselEl.querySelectorAll(".cell");
    slides.forEach((slide) => {
      slide.addEventListener("click", function () {
        let targetIndex = slide.getAttribute("data-id");
        flkty.select(targetIndex);
      });
    });
  }

  // autoplay logo carousel

  function logoCarouselInit() {
    let carouselParent = logoCarouselEl.closest(".logo_carousel");
    let tickerSpeed = -1;
    if (carouselParent.classList.contains("perks")) {
      tickerSpeed = 0.7;
    }
    let isPaused = false;
    let flktyLogos;

    const update = () => {
      if (isPaused) return;
      if (flktyLogos.slides) {
        flktyLogos.x = (flktyLogos.x + tickerSpeed) % flktyLogos.slideableWidth;
        //flktyLogos.x = flktyLogos.x * -1;

        flktyLogos.selectedIndex = flktyLogos.dragEndRestingSelect();
        flktyLogos.updateSelectedSlide();
        flktyLogos.settle(flktyLogos.x);
      }
      window.requestAnimationFrame(update);
    };

    const pause = () => {
      isPaused = true;
    };

    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };

    flktyLogos = new Flickity(logoCarouselEl, {
      // options
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      wrapAround: true,
      groupCells: 4,
      selectedAttraction: 0.015,
      friction: 0.25,
    });
    flktyLogos.x = 0;

    update();

    // create click events for the arrows that pause, advance and then play the carousel
    let logoCarouselArrows = carouselParent.querySelectorAll(".arrow");
    logoCarouselArrows.forEach((logoCarouselArrow) => {
      logoCarouselArrow.addEventListener("click", function () {
        pause();
        if (logoCarouselArrow.classList.contains("arrow_next")) {
          flktyLogos.next();
          tickerSpeed = -1;
        } else {
          flktyLogos.previous();
          tickerSpeed = 1;
        }
        setTimeout(play, 500);
      });
    });
  }

  let logoCarouselEl = document.querySelector(".logo_carousel .items");
  if (typeof logoCarouselEl != "undefined" && logoCarouselEl != null) {
    logoCarouselInit();
  }

  // initialize flickity for carousels
  let slideshowMediumEl = document.querySelector(".slideshow.medium");
  if (typeof slideshowMediumEl != "undefined" && slideshowMediumEl != null) {
    let flkty = new Flickity(slideshowMediumEl, {
      // options
      cellSelector: ".cell",
      prevNextButtons: false,
      pageDots: true,
      draggable: true,
      autoPlay: 3000,
      pauseAutoPlayOnHover: false,
      wrapAround: true,
    });

    let slides = slideshowMediumEl.querySelectorAll(".cell");
    slides.forEach((slide) => {
      slide.addEventListener("click", function () {
        let targetIndex = slide.getAttribute("data-id");
        flkty.select(targetIndex);
      });
    });
  }

  let slideshowLargerEl = document.querySelector(".slideshow.larger");
  if (typeof slideshowLargerEl != "undefined" && slideshowLargerEl != null) {
    let flkty = new Flickity(slideshowLargerEl, {
      // options
      cellSelector: ".cell",
      prevNextButtons: false,
      pageDots: true,
      draggable: false,
      wrapAround: true,
    });
  }

  //initialize flickity for slideshows

  let slideshowLargeEl = document.querySelector(".slideshow.large");
  if (typeof slideshowLargeEl != "undefined" && slideshowLargeEl != null) {
    let flkty = new Flickity(slideshowLargeEl, {
      // options
      fade: true,
      cellSelector: ".cell",
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      autoPlay: 3000,
      pauseAutoPlayOnHover: false,
      wrapAround: true,
    });

    // clicking anywhere on cell goes next
    let slideCells = slideshowLargeEl.querySelectorAll(".cell");
    slideCells.forEach((slideCell) => {
      slideCell.addEventListener("click", function (e) {
        flkty.next();
      });
    });

    // pager dot goes to specific slide
    let pagerDots = slideshowLargeEl.querySelectorAll(".slide-dots li");
    pagerDots.forEach((pagerDot) => {
      pagerDot.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let id = pagerDot.getAttribute("data-id");
        flkty.select(id);
      });
    });

    /*

    // change event
    flkty.on("change", function (index) {
      let slideCount = index + 1;
      counterEl.innerHTML = slideCount;
    });

    */
  }

  let slideshowCardsEl = document.querySelector(
    ".slideshow_wrapper_cards .slides",
  );
  if (typeof slideshowCardsEl != "undefined" && slideshowCardsEl != null) {
    let flkty = new Flickity(slideshowCardsEl, {
      // options
      fade: false,
      cellSelector: ".slide",
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      autoPlay: 0,
      pauseAutoPlayOnHover: true,
      wrapAround: true,
    });

    let pagerDots = slideshowCardsEl.querySelectorAll(".slide-dots li");
    pagerDots.forEach((pagerDot) => {
      pagerDot.addEventListener("click", function (e) {
        e.preventDefault();
        let id = pagerDot.getAttribute("data-id");
        let targetSlide = slideshowCardsEl.querySelector(
          ".cell[data-id='" + id + "']",
        );
        flkty.select(id);
      });
    });

    /*

    // change event
    flkty.on("change", function (index) {
      let slideCount = index + 1;
      counterEl.innerHTML = slideCount;
    });

    */
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  let sizeLoadVideoEls = document.querySelectorAll(".sizeload");
  sizeLoadVideoEls.forEach((sizeLoadVideoEl) => {
    sizeloadVideo(sizeLoadVideoEl);
  });

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.play();
    }
    el.classList.add("autoplaying");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("autoplaying");
  }

  function loadImage(image) {
    if (image.classList.contains("loaded")) {
      return;
    }

    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = "/images/pics/1920/" + img;
      } else {
        imgpath = "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    let colCheck = el.querySelector(".col");
    if (typeof colCheck != "undefined" && colCheck != null) {
      Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
        elContainer.appendChild(c);
      });
      elContainer.classList.add("cols");
      el.appendChild(elContainer);
    }
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    overlay.classList.add("on");
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    overlayInner.innerHTML = "";
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {
    // handle resizing of AR Rows
    let arRowsCell = document.querySelectorAll(".ar-rows .row .cell");
    for (let i = 0; i < arRowsCell.length; ++i) {
      var _this = arRowsCell[i],
        container = _this.closest(".ar-rows"),
        rowsMargin = container.getAttribute("data-margin"),
        percW = _this.getAttribute("data-percW"),
        percH = _this.getAttribute("data-percH"),
        ratio = _this.getAttribute("data-ratio"),
        num = _this.getAttribute("data-numImages"),
        containerWidth = container.offsetWidth - rowsMargin * (num - 1);

      _this.style.width = containerWidth * percW + "px";
      let cellImg = _this.querySelector("img");
      cellImg.style.height = ratio * (containerWidth * percW) + "px";
    }
  }

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // fullwidth video sound btns

  function soundBtnsInit() {
    //console.log("btn init");

    let soundBtns = document.querySelectorAll(".sound_btn");
    soundBtns.forEach((soundBtn) => {
      let cell = soundBtn.closest(".cell");
      let fullVideo = cell.querySelector("video.fullvideo");
      let embedFrame = cell.querySelector(".embed_parent iframe");
      let termlyBlock = cell.querySelector(".termly-blocked-content");
      let player;

      // if embed code is found, set volume to 0 and start autoplay
      if (
        typeof embedFrame != "undefined" &&
        embedFrame != null &&
        !termlyBlock
      ) {
        try {
          player = new Player(embedFrame);
          player.setVolume(0);
          player.play();
          cell.querySelector(".embed_parent").classList.add("playing");
        } catch (error) {
          console.error("Error initializing video player:", error);
        }
      }

      soundBtn.addEventListener("click", function (e) {
        e.preventDefault();

        if (
          (typeof fullVideo != "undefined" && fullVideo != null) ||
          termlyBlock
        ) {
          fullVideo.muted = !fullVideo.muted;
          fullVideo.setAttribute("controls", true);
        } else {
          cell.querySelector(".embed_parent").classList.add("with_sound");
          player.setVolume(1);
        }
        soundBtn.classList.add("hide");
      });
    });
  }
  //soundBtnsInit();

  // custom select carrot needs to hide after selection is made
  let selectFields = document.querySelectorAll("select");
  selectFields.forEach((selectField) => {
    let selectCarrot = selectField.nextElementSibling;
    selectField.addEventListener("input", function (e) {
      let selVal = e.target.value;
      if (selVal != "") {
        selectCarrot.style.opacity = 0;
      } else {
        selectCarrot.style.opacity = 1;
      }
    });
  });

  // job board events

  function removeActiveJBFitler() {
    jbFilters.forEach((jbFilter) => {
      jbFilter.classList.remove("pageOn");
    });
  }

  let jbFilters = document.querySelectorAll(".jobBoard .jobFilter li a");
  let jbListings = document.querySelectorAll(".jobBoard .listings");
  jbFilters.forEach((jbFilter) => {
    jbFilter.addEventListener("click", function (e) {
      e.preventDefault();
      let location = jbFilter.getAttribute("data-location");
      removeActiveJBFitler();
      jbFilter.classList.add("pageOn");
      jbListings.forEach((jbListing) => {
        jbListing.classList.remove("active");
      });
      document
        .querySelector(".jobBoard .listings[data-location='" + location + "']")
        .classList.add("active");
    });
  });

  let jbRowTriggers = document.querySelectorAll(".jobBoard .row .trigger");
  jbRowTriggers.forEach((jbRowTrigger) => {
    jbRowTrigger.addEventListener("click", function (e) {
      e.preventDefault();

      let jobRow = jbRowTrigger.closest(".row");
      let jobList = jobRow.querySelector(".jobs");
      let jobH = jobList.offsetHeight + 90;
      if (jobRow.classList.contains("open")) {
        jobH = 90;
      }

      jobRow.classList.toggle("open");
      jobRow.style.height = jobH + "px";
    });
  });

  function removeActiveListItem() {
    slideshowTextItems.forEach((slideshowTextItem) => {
      slideshowTextItem.classList.remove("active");
    });
    slideshowTextSlides.forEach((slideshowTextSlide) => {
      slideshowTextSlide.classList.remove("active");
    });
  }

  // slideshow text list clicks
  let slideshowTextItems = document.querySelectorAll(
    ".slideshow.text_list .list li",
  );
  let slideshowTextSlides = document.querySelectorAll(
    ".slideshow.text_list .media .slide",
  );
  slideshowTextItems.forEach((slideshowTextItem) => {
    slideshowTextItem.addEventListener("click", function (e) {
      // Only trigger if the click is on .icon or .title (or their children)
      if (e.target.closest(".icon") || e.target.closest(".title")) {
        e.preventDefault();
        let itemId = slideshowTextItem.getAttribute("data-id");
        removeActiveListItem();
        slideshowTextItem.classList.add("active");
        document
          .querySelector(
            ".slideshow.text_list .media .slide[data-id='" + itemId + "']",
          )
          .classList.add("active");
      }
    });
  });

  // work load more button
  let loadMoreBtn = document.querySelector(".load_more");
  let loadMoreLoading = false;
  if (typeof loadMoreBtn != "undefined" && loadMoreBtn != null) {
    loadMoreBtn.addEventListener("click", function () {
      // ignore clicks while a request is already in flight
      if (loadMoreLoading) return;

      let id = loadMoreBtn.getAttribute("data-id");
      let start = parseInt(loadMoreBtn.getAttribute("data-start"), 10);
      let total = parseInt(loadMoreBtn.getAttribute("data-total"), 10);
      let grid = loadMoreBtn.previousElementSibling;

      if (start <= total) {
        loadMoreLoading = true;
        loadMoreBtn.classList.add("loading");

        let xhr = getAjax(
          "/getProjects.php?id=" + id + "&start=" + start,
          function (data) {
            grid.insertAdjacentHTML("beforeend", data);
            inviewInit();
            observeMobileGridCells(grid);
            let newEls = grid.querySelectorAll(".cell.new");
            iso.appended(newEls);

            newEls.forEach((newCell) => {
              newCell.classList.remove("new");
            });

            // update start attribute for next set
            let newStart = start + 10;
            if (newStart >= total) {
              loadMoreBtn.classList.add("hide");
            } else {
              loadMoreBtn.setAttribute("data-start", newStart);
            }
          },
        );

        // fires on success or failure, so the button never stays locked
        xhr.addEventListener("loadend", function () {
          loadMoreLoading = false;
          loadMoreBtn.classList.remove("loading");
        });
      }
    });
  }

  // work/news filter change event for ISO sorting

  let gridFilterTrigger = document.querySelector(".filter_trigger");
  if (typeof gridFilterTrigger != "undefined" && gridFilterTrigger != null) {
    let filterForm = gridFilterTrigger.closest(".filter_form");
    let workFilter = gridFilterTrigger.closest(".work_filter");

    gridFilterTrigger.addEventListener("click", function () {
      filterForm.classList.toggle("open");
      workFilter.classList.toggle("open");
    });

    // close filter when clicking anywhere outside of filter list
    let filterCloser = document.querySelector(".work_filter .cover");
    filterCloser.addEventListener("click", function () {
      filterForm.classList.remove("open");
      workFilter.classList.remove("open");
    });
  }

  function removeActiveFilters() {
    let itemFilterSelects = document.querySelectorAll(".filter_list li");
    itemFilterSelects.forEach((itemFilterSelect) => {
      itemFilterSelect.classList.remove("active");
    });
  }

  function filterBtns() {
    let filterBtns = document.querySelectorAll(".filter_btns span");
    filterBtns.forEach((filterBtn) => {
      filterBtn.addEventListener("click", function () {
        let btnFilter = filterBtn.getAttribute("data-filter");
        isoFilterArray = isoFilterArray.filter((e) => e !== btnFilter);

        // convert items in array into str for ISO filtering
        let isoFilterStr = "";
        isoFilterArray.forEach((isoFilter) => {
          isoFilterStr += "." + isoFilter + ", ";
        });
        isoFilterClean = isoFilterStr.slice(0, -2);

        iso.arrange({ filter: isoFilterClean });

        // remove button from dom
        filterBtn.parentNode.removeChild(filterBtn);
      });
    });
  }

  let isoFilterArray = [];
  let isoFilterClean = "";
  let itemFilterSelects = document.querySelectorAll(".filter_list li");
  itemFilterSelects.forEach((itemFilterSelect) => {
    itemFilterSelect.addEventListener("click", function () {
      let filterWrap = itemFilterSelect.closest(".work_filter");
      let id = filterWrap.getAttribute("data-id");
      let grid = filterWrap.nextElementSibling;

      // close the closer el
      document.querySelector(".work_filter").classList.remove("open");

      if (
        typeof id != "undefined" &&
        id != null &&
        !loadMoreBtn.classList.contains("hide")
      ) {
        // if the filter is used we need to load all projects on the page
        getAjax("/getAllProjects.php?id=" + id, function (data) {
          grid.insertAdjacentHTML("beforeend", data);
          observeMobileGridCells(grid);
          let newEls = grid.querySelectorAll(".cell.new");
          iso.appended(newEls);

          newEls.forEach((newCell) => {
            newCell.classList.remove("new");
          });

          loadMoreBtn.classList.add("hide");

          setTimeout(function () {
            inviewAjaxInit();
          }, 500);
        });
      } else {
        // remove fadeUp Class after filter has been used
        let gridItemsFade = grid.querySelectorAll(".fadeUp");
        gridItemsFade.forEach((gridItemFade) => {
          gridItemFade.classList.add("fadeUpShow");
        });
      }

      let filterForm = filterWrap.querySelector(".filter_form");
      let filterBtnsWrap = filterWrap.querySelector(".filter_btns");
      let theFilterSlugClean = itemFilterSelect.getAttribute("data-filter");
      let theFilterSlug = "." + itemFilterSelect.getAttribute("data-filter");
      let theFilterLabel = itemFilterSelect.getAttribute("data-label");

      // if selected option is already used, close the list
      if (itemFilterSelect.classList.contains("active")) {
        filterForm.classList.remove("open");
        return;
      }

      itemFilterSelect.classList.add("active");

      if (theFilterSlug === ".all") {
        isoFilterArray = [];
        isoFilterArray.push("all");
      } else {
        isoFilterArray = isoFilterArray.filter((e) => e !== "all");
        isoFilterArray.push(theFilterSlugClean);
      }

      // convert items in array into str for ISO filtering
      let isoFilterStr = "";
      isoFilterArray.forEach((isoFilter) => {
        isoFilterStr += "." + isoFilter + ", ";
      });
      isoFilterClean = isoFilterStr.slice(0, -2);

      iso.arrange({ filter: isoFilterClean });

      if (theFilterSlug === ".all") {
        filterBtnsWrap.innerHTML = "";
        removeActiveFilters();
      } else {
        let newBtn = document.createElement("span");
        newBtn.classList.add("filter");
        newBtn.setAttribute("data-filter", theFilterSlugClean);
        newBtn.innerHTML = theFilterLabel;
        filterBtnsWrap.appendChild(newBtn);
      }
      filterForm.classList.remove("open");
      filterBtns();
    });
  });

  // on page load with hash value, trigger filter
  let filterHash = window.location.hash;
  let workPageCheck = document.querySelector(".work_filter");
  if (
    typeof workPageCheck != "undefined" &&
    workPageCheck != null &&
    filterHash != ""
  ) {
    let cleanHash = filterHash.replace("#", "");
    let targetFilterEl = document.querySelector(
      ".filter_list li[data-filter='" + cleanHash + "']",
    );
    targetFilterEl.click();
    // scroll to work filter
    zenscroll.to(workPageCheck);
  }

  // contact button overlay
  let contractTriggerEls = document.querySelectorAll(".contactTrigger");
  contractTriggerEls.forEach((contactTriggerEl) => {
    contactTriggerEl.addEventListener("click", function (e) {
      e.preventDefault();
      openOverlay();
    });
  });

  let contactFormCloseEl = document.querySelector(".contact_form .closeForm");
  if (typeof contactFormCloseEl != "undefined" && contactFormCloseEl != null) {
    contactFormCloseEl.addEventListener("click", function (e) {
      e.preventDefault();
      closeOverlay();
    });
  }

  // play full videos
  let playIcons = document.querySelectorAll(".playVideo");
  playIcons.forEach((playIcon) => {
    playIcon.addEventListener("click", function () {
      let cell = playIcon.closest(".cell");
      let videoType = cell.getAttribute("data-type");
      let vidHold = cell.querySelector(".vidhold");

      let video;
      if (videoType === "file") {
        video = cell.getAttribute("data-video");
        vidHold.innerHTML = video;
      } else {
        let embed = vidHold.querySelector("iframe");
        let embedSrc = embed.getAttribute("src");

        if (typeof embedSrc != "undefined" && embedSrc != null) {
          let vimeoCheck = embedSrc.indexOf("vimeo");

          if (vimeoCheck >= 0) {
            var player = new Player(embed);
            player.play();
          } else {
            let newSrc = embedSrc + "?autoplay=1";
            embed.setAttribute("allowautoplay", true);
            embed.setAttribute("src", newSrc);
          }
        }
      }

      cell.classList.add("playing");
    });
  });

  // overlay links
  let overlayLinks = document.querySelectorAll(".openOverlay");
  overlayLinks.forEach((overlayLink) => {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      let id = overlayLink.getAttribute("data-id");
      getAjax("/getItem.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        openOverlay();
        let videoEl = overlayInner.querySelector("video");
        if (typeof videoEl != "undefined" && videoEl != null) {
          videoEl.play();
        }
        let embedEl = overlayInner.querySelector("iframe");
        if (typeof embedEl != "undefined" && embedEl != null) {
          let embedSrc = embedEl.getAttribute("src");

          if (typeof embedSrc != "undefined" && embedSrc != null) {
            let vimeoCheck = embedSrc.indexOf("vimeo");

            if (vimeoCheck >= 0) {
              var player = new Player(embedEl);
              player.play();
            } else {
              let newSrc = embedSrc + "?autoplay=1";
              embedEl.setAttribute("allowautoplay", true);
              embedEl.setAttribute("src", newSrc);
            }
          }
        }
      });
    });
  });

  //hamburger menu toggle
  const menuBtnLabel = menuBtn.querySelector(".label");
  const navItems = nav.querySelectorAll("li");
  menuBtn.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      body.classList.toggle("menuOn");

      const isOpen = body.classList.contains("menuOn");
      menuBtnLabel.textContent = isOpen ? "CLOSE" : "MENU";

      if (isOpen) {
        gsap.fromTo(
          navItems,
          { opacity: 0, y: 20 },
          {
            opacity: 1,
            y: 0,
            stagger: 0.08,
            duration: 0.4,
            ease: "power2.out",
            delay: 0.4,
          },
        );
        // close open menu when clicking anywhere on main
        mainEl.addEventListener("click", function () {
          body.classList.remove("menuOn");
          menuBtnLabel.textContent = "MENU";

          gsap.set(navItems, { opacity: 0, y: 20, delay: 0.5 });
        });
      }
    },
    true,
  );

  // close overlay
  overlayCloser.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      closeOverlay();
    },
    true,
  );

  // fit last name to full viewport width on bio detail pages
  const lastNameH1 = document.querySelector(".bio_detail .hero .last-name h1");
  if (lastNameH1) {
    const fitLastName = () => {
      lastNameH1.style.fontSize = "100px";
      lastNameH1.style.width = "max-content";
      const textWidth = lastNameH1.scrollWidth;
      lastNameH1.style.width = "";
      const scale = window.innerWidth / textWidth;
      lastNameH1.style.fontSize = `${100 * scale}px`;
      lastNameH1.style.opacity = 1;
    };
    document.fonts.ready.then(fitLastName);
    window.addEventListener("resize", fitLastName);
  }
});
